import { useEffect, useState } from "react";

type CustomForm<FormData, SubmitData> = {
    formState: FormData;
    setFormState: (newValue: FormData) => void;
    formSubmit: () => SubmitData | null;
    resetForm: () => void;
};

type CustomOptions<InputData, FormData, SubmitData> = {
    inputData: InputData;
    serialize: (data: InputData) => FormData;
    onSubmit: (data: FormData) => SubmitData | null;
};

export const useCustomForm = <InputData, FormData, SubmitData>(
    options: CustomOptions<InputData, FormData, SubmitData>,
): CustomForm<FormData, SubmitData> => {
    const { serialize, onSubmit, inputData } = options;

    const initialData = serialize(inputData);
    const [formState, setFormState] = useState<FormData>(initialData);

    useEffect(() => {
        const newInitialData = serialize(inputData);
        setFormState(newInitialData);
    }, [inputData]);

    const formSubmit = () => onSubmit(formState);
    const resetForm = () => setFormState(initialData);

    return { formState, setFormState, formSubmit, resetForm };
};
